/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_Pending_ResultsInputs */



/**
* | output |
* | --- |
* | "Results not yet sent to vekn.net" |
*
* @param {Vekn_Sync_Pending_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_pending_results = /** @type {((inputs?: Vekn_Sync_Pending_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_Pending_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats pas encore envoyés à vekn.net")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados aún no enviados a vekn.net")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resultados ainda não enviados para vekn.net")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultati non ancora inviati a vekn.net")
	return /** @type {LocalizedString} */ ("Results not yet sent to vekn.net")
});